import { IRoadLayoutConfig, CarriageWayEnum } from "types";

export const images = {
  road: {
    border: {
      left: require("assets/images/road/border-left.svg").default,
      right: require("assets/images/road/border-right.svg").default,
    },
    single: {
      default: require("assets/images/road/single.svg").default,
      selected: require("assets/images/road/single-selected.svg").default,
      borderLeft: require("assets/images/road/single-border-left.svg").default,
      borderRight: require("assets/images/road/single-border-right.svg").default,
      borderBoth: require("assets/images/road/single-border-both.svg").default,
    },
    double: {
      default: require("assets/images/road/double.svg").default,
      selected: require("assets/images/road/double-selected.svg").default,
      borderLeft: require("assets/images/road/double-border-left.svg").default,
      borderRight: require("assets/images/road/double-border-right.svg").default,
      borderBoth: require("assets/images/road/double-border-both.svg").default,
    },
  },

  layout: {
    double: {
      single: {
        none: require("assets/images/layout/double-single-border-none.svg").default,
        left: require("assets/images/layout/double-single-border-left.svg").default,
        right: require("assets/images/layout/double-single-border-right.svg").default,
        both: require("assets/images/layout/double-single-border-both.svg").default,
      },
      double: {
        none: require("assets/images/layout/double-double-border-none.svg").default,
        left: require("assets/images/layout/double-double-border-left.svg").default,
        right: require("assets/images/layout/double-double-border-right.svg").default,
        both: require("assets/images/layout/double-double-border-both.svg").default,
      },
      both: {
        none: require("assets/images/layout/double-both-border-none.svg").default,
        left: require("assets/images/layout/double-both-border-left.svg").default,
        right: require("assets/images/layout/double-both-border-right.svg").default,
        both: require("assets/images/layout/double-both-border-both.svg").default,
      },
      rope: {
        none: require("assets/images/layout/double-rope-border-none.svg").default,
        left: require("assets/images/layout/double-rope-border-left.svg").default,
        right: require("assets/images/layout/double-rope-border-right.svg").default,
        both: require("assets/images/layout/double-rope-border-both.svg").default,
      },
    },
    single: {
      left: {
        none: require("assets/images/layout/single-left-border-none.svg").default,
        left: require("assets/images/layout/single-left-border-left.svg").default,
        right: require("assets/images/layout/single-left-border-right.svg").default,
        both: require("assets/images/layout/single-left-border-both.svg").default,
      },
      right: {
        none: require("assets/images/layout/single-right-border-none.svg").default,
        left: require("assets/images/layout/single-right-border-left.svg").default,
        right: require("assets/images/layout/single-right-border-right.svg").default,
        both: require("assets/images/layout/single-right-border-both.svg").default,
      },
      both: {
        none: require("assets/images/layout/single-both-border-none.svg").default,
        left: require("assets/images/layout/single-both-border-left.svg").default,
        right: require("assets/images/layout/single-both-border-right.svg").default,
        both: require("assets/images/layout/single-both-border-both.svg").default,
      },
      staggered: {
        none: require("assets/images/layout/single-staggered-border-none.svg").default,
        left: require("assets/images/layout/single-staggered-border-left.svg").default,
        right: require("assets/images/layout/single-staggered-border-right.svg").default,
        both: require("assets/images/layout/single-staggered-border-both.svg").default,
      },
      rope: {
        none: require("assets/images/layout/single-rope-border-none.svg").default,
        left: require("assets/images/layout/single-rope-border-left.svg").default,
        right: require("assets/images/layout/single-rope-border-right.svg").default,
        both: require("assets/images/layout/single-rope-border-both.svg").default,
      },
    },
  },
};

export type RoadType = keyof typeof images.road;

export type LayoutType = keyof typeof images.layout;

export type SingleLayoutType = keyof typeof images.layout.single;

export type DoubleLayoutType = keyof typeof images.layout.double;

export type LuminaireLayoutType = SingleLayoutType | DoubleLayoutType;

export const getCarriageWayImage = (roadLayout: IRoadLayoutConfig, carriageWay: CarriageWayEnum): string => {
  const imgs = images.road;

  const isSingle = carriageWay === CarriageWayEnum.SINGLE;
  if (roadLayout.carriageWay !== carriageWay) return isSingle ? imgs.single.default : imgs.double.default;

  const { borderAreaLeft, borderAreaRight } = roadLayout;
  if (borderAreaLeft && borderAreaRight) return isSingle ? imgs.single.borderBoth : imgs.double.borderBoth;
  if (borderAreaLeft) return isSingle ? imgs.single.borderLeft : imgs.double.borderLeft;
  if (borderAreaRight) return isSingle ? imgs.single.borderRight : imgs.double.borderRight;

  return isSingle ? imgs.single.selected : imgs.double.selected;
};

export const getLuminaireLayoutImage = (
  carriageway: LayoutType,
  position: LuminaireLayoutType,
  currentRoadLayout: IRoadLayoutConfig
) => {
  const imgs = images.layout;

  const { borderAreaLeft, borderAreaRight } = currentRoadLayout;
  const borders = borderAreaLeft ? (borderAreaRight ? "both" : "left") : borderAreaRight ? "right" : "none";

  if (carriageway === "single" && position in imgs.single) {
    return imgs.single[position as SingleLayoutType][borders];
  }

  if (carriageway === "double" && position in imgs.double) {
    return imgs.double[position as DoubleLayoutType][borders];
  }

  return imgs.single.both[borders];
};
